import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  BulkUpdateAssignmentsInput,
  MutationUpdateBulkAssignmentResponse,
  BulkUpdateAssignmentsInputVariables,
} from '../types';

const updateBulkFlexibleComponentsAssignmentsMutation = gql`
  mutation UpdateBulkFlexibleAssignments($input: BulkUpdateAssignmentInput!) {
    payrollBulkUpdateAssignments(input: $input) {
      assignment_ids
      code
      success
      message
    }
  }
`;

export const updateBulkFlexibleComponentsAssignments = (
  input: BulkUpdateAssignmentsInputVariables,
) => {
  return graphQLApi<MutationUpdateBulkAssignmentResponse, BulkUpdateAssignmentsInput>({
    query: updateBulkFlexibleComponentsAssignmentsMutation,
    queryVariables: { input },
  });
};
